import React, { Component } from 'react';
import { ButtonPrimary } from 'ui';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { UserGroupCodeModal } from './user-group-code-modal';
import { UserGroupListContent } from 'app/area/codetable/list/list-renderer/screens/user-group/user-group-list-content';
import { CodetableListDragPreview } from 'app/area/codetable/list/list-items/drag-and-drop/codetable-drag-preview';
import { MergeCodeContainer } from 'app/area/codetable/common/merge-code/merge-code-container';

export class UserGroupListComponent extends Component<CodetableListComponentProps> {
  public render() {

    const { breadcrumbs, codetableId,
      codeAccessConfiguration: { canCreate } = {}, codetableOptions,
      translation, loadCodetableOptions } = this.props;

    const rightToolbar = canCreate && <UserGroupCodeModal
      label={translation.add_new}
      codetableId={codetableId}
      breadcrumbs={breadcrumbs}
      parentId={undefined}
      codetableOptions={codetableOptions}
      loadCodetableOptions={loadCodetableOptions}
      ButtonComponent={ButtonPrimary}
      translation={translation}
    />;

    return <SearchFilters {...this.props} rightToolbar={rightToolbar}>
      <CodetableListDragPreview {...this.props} wrappedComponent={UserGroupListContent} />
      <MergeCodeContainer {...this.props} />
    </SearchFilters>;
  }
}
